import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { updateLayoutOptions } from '../../../redux/ChartPoperties/ChartControlsActions';
import RenderManualLayoutControls from './ManualLayoutControls';

const TableLayout = ({ iconColor }: { iconColor?: string }) => {
  const { chartControls, tabTileProps } = useSelector((state: RootState) => ({
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  }));

  const dispatch = useDispatch();

  const propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const tableLayout = chartControls.properties[propKey]?.layoutOptions?.tableLayout || 'shrinked';

  const layoutOptions = [
    {
      type: 'shrinked',
      title: 'Shrinked Layout',
    },
    {
      type: 'stretched',
      title: 'Stretched Layout',
    },
  ];

  const RenderTableLayoutOptions = () =>
    layoutOptions.map((option) => {
      const isSelected = option.type === tableLayout;

      const handleButtonSelect = () => {
        dispatch(updateLayoutOptions(propKey, 'tableLayout', option.type));
      };

      return (
        <div
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          title={option.title}
          key={option.type}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            fontWeight: isSelected ? '600' : 'normal',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '6px 10px',
            minHeight: '28px',
            flex: '1 1 0%',
          }}
          onClick={handleButtonSelect}
        >
          <span>{option.type}</span>
        </div>
      );
    });

  return (
    <>
      <div className="optionsInfo">
        <div
          className="optionDescription"
          style={{ paddingTop: '0', marginBottom: '4px', color: iconColor ? iconColor : '#404040' }}
        >
          Table Layout
        </div>
        <div className="radioButtons">
          <RenderTableLayoutOptions />
        </div>
        {tableLayout === 'shrinked' && (
          <>
            <RenderManualLayoutControls propKey={propKey} iconColor={iconColor} />
          </>
        )}
      </div>
    </>
  );
};

export default TableLayout;
